import { action as apiAction } from 'api/Api'
import {
  remove as removeElement
} from '../redux/elements'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  cardId: number
  elementId: number
}

const requestRemoveElement = (payload: Payload) => async dispatch => {
  const { cardId, elementId } = payload

  const optimisticAction = optimisticDispatch(dispatch, removeElement({
    cardId,
    elementId: elementId
  }))

  try {
    await apiAction('RemoveElement', {
      id: elementId
    })

    optimisticAction.commit()
  } catch (error) {
    optimisticAction.revert()

    throw error
  }
}

export default requestRemoveElement
